import { getKennzahl, Kennzahl } from '../strukturiert/Kennzahl';

export function isRenewableStrom(co2_faktor: number): boolean {
    const isRenewable: boolean = co2_faktor > 0 && co2_faktor < 0.0001;
    if (isRenewable) {
        // console.log('strom', co2_faktor);
    }
    return isRenewable;
}

export function isRenewableWaerme(energietraeger: string, co2_faktor: number): boolean {
    const isRenewableBio: boolean = ['bio_hackschnitzel', 'bio_holzpellets', 'bio_brennholz', 'biogas'].includes(energietraeger);
    const isRenewableFwFk: boolean = ['fernwaerme', 'fernkaelte'].includes(energietraeger) && co2_faktor > 0 && co2_faktor < 0.0001;
    const isRenewable: boolean = isRenewableBio || isRenewableFwFk;
    if (isRenewable) {
        // console.log(energietraeger, co2_faktor);
    }
    return isRenewable;
}

// export function isRenewableKraftstoffe(co2_faktor: number): boolean {
//     const isRenewable: boolean = co2_faktor > 0 && co2_faktor < 0.0001;
//     if (isRenewable) {
//         // console.log(energietraeger, co2_faktor);
//     }
//     return isRenewable;
// }

export function setKennzahlRenewableStrom(item: any, globalData: any, verbrauch: number, co2_emission: number, kennzahlVerbracuh?: Kennzahl, kennzahlCo2?: Kennzahl) {
    // Für Strom
    setKennzahlRenewable(item, globalData, verbrauch, co2_emission, kennzahlVerbracuh, kennzahlCo2, 'strom', 'Strom');
    // Für Gesamt
    setKennzahlRenewable(item, globalData, verbrauch, co2_emission, kennzahlVerbracuh, kennzahlCo2);
}

export function setKennzahlRenewableWaerme(item: any, globalData: any, verbrauch: number, co2_emission: number, kennzahlVerbracuh?: Kennzahl, kennzahlCo2?: Kennzahl) {
    // Für Wärme
    setKennzahlRenewable(item, globalData, verbrauch, co2_emission, kennzahlVerbracuh, kennzahlCo2, 'waerme', 'Wärme');
    // Für Gesamt
    setKennzahlRenewable(item, globalData, verbrauch, co2_emission, kennzahlVerbracuh, kennzahlCo2);
}

// export function setKennzahlRenewableKraftstoffe(item: any, globalData: any, verbrauch: number, co2_emission: number, kennzahlVerbracuh?: Kennzahl, kennzahlCo2?: Kennzahl) {
//     // Für Kraftstoffe
//     setKennzahlRenewable(item, globalData, verbrauch, co2_emission, kennzahlVerbracuh, kennzahlCo2, 'kraftstoffe', 'Kraftstoffe');
//     // Für Gesamt
//     setKennzahlRenewable(item, globalData, verbrauch, co2_emission, kennzahlVerbracuh, kennzahlCo2);
// }

export function setKennzahlRenewable(item: any, globalData: any, verbrauch: number, co2_emission: number, kennzahlVerbracuh?: Kennzahl, kennzahlCo2?: Kennzahl,
    teilKey?: string, teilName?: string
) {
    // Verbrauch
    if (kennzahlVerbracuh && verbrauch > 0) {
        const kennKey = `renewable_verbrauch_${teilKey ? `${teilKey}_${item.standort_tid_orig}` : 'gesamt'}`;
        const kennName = `Verbrauch (erneuerbar) ${teilName ? ` ${teilName} - ${item.standort_tid}` : 'Gesamt'} `;
        const gesamtKey = `renewable_verbrauch_${teilKey || 'temp'}`;
        const gesamtName = `Verbrauch (erneuerbar) ${teilName || '(temp)'}`;
        const kenn_menge: Kennzahl = getKennzahl(kennKey, 'verbrauch', item.jahr, item.standort_tid_orig, globalData);
        if (!kenn_menge.isInitialized()) {
            kenn_menge
                .setBereich(Kennzahl.BEREICH_RENEWABLE)
                .setType(Kennzahl.TYPE_SUMME)
                .setEinheit('kWh')
                .setName(kennName)
                .setGesamt(gesamtKey)
                .setGesamtName(gesamtName);
        }
        kenn_menge.addValue(verbrauch, item.tid, kennzahlVerbracuh);
        // if (teilKey) {
        //     console.log(item.jahr, item.standort_tid, item.energietraeger_tid || teilName, co2_emission, verbrauch);
        // }
    }
    // CO2
    if (kennzahlCo2 && co2_emission > 0) {
        const kennKeyCo2 = `renewable_co2_${teilKey ? `${teilKey}_${item.standort_tid_orig}` : 'gesamt'}`;
        const kennNameCo2 = `CO₂-Emission (erneuerbar) ${teilName ? ` ${teilName} - ${item.standort_tid}` : 'Gesamt'} `;
        const gesamtKeyCo2 = `renewable_co2_${teilKey || 'temp'}`;
        const gesamtNameCo2 = `CO₂-Emission (erneuerbar) ${teilName || '(temp)'}`;
        const kenn_co2: Kennzahl = getKennzahl(kennKeyCo2, 'co2', item.jahr, item.standort_tid_orig, globalData);
        if (!kenn_co2.isInitialized()) {
            kenn_co2
                .setBereich(Kennzahl.BEREICH_RENEWABLE)
                .setType(Kennzahl.TYPE_SUMME)
                .setEinheit('tCO₂Äq')
                .setName(kennNameCo2)
                .setGesamt(gesamtKeyCo2)
                .setGesamtName(gesamtNameCo2);
        }
        kenn_co2.addValue(co2_emission, item.tid, kennzahlCo2);
    }
}

